import { ChevronDown, HelpCircle } from 'lucide-react';
import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Les paris en ligne sont-ils légaux en France ?',
      answer: 'Oui, les paris en ligne sont légaux en France depuis 2010. Cependant, vous devez utiliser uniquement des plateformes agréées par l\'Autorité Nationale des Jeux (ANJ). Toutes les plateformes présentées sur Hexabet Connect sont agréées et sécurisées.',
    },
    {
      question: 'Comment puis-je retirer mes gains ?',
      answer: 'Les méthodes de retrait varient selon les plateformes. Les options courantes incluent les virements bancaires, les portefeuilles électroniques, et les cartes bancaires. Les délais de traitement sont généralement de 24 à 72 heures pour les virements bancaires.',
    },
    {
      question: 'Les bonus sont-ils vraiment gratuits ?',
      answer: 'Les bonus de bienvenue sont offerts sans dépôt supplémentaire, mais ils sont soumis à des conditions de mise (wagering requirements). Vous devez généralement miser le montant du bonus plusieurs fois avant de pouvoir retirer les gains. Lisez toujours les conditions générales avant d\'accepter un bonus.',
    },
    {
      question: 'Puis-je avoir plusieurs comptes sur différentes plateformes ?',
      answer: 'Oui, vous pouvez avoir un compte sur chaque plateforme agréée. Cependant, vous ne pouvez avoir qu\'un seul compte par plateforme. Créer plusieurs comptes sur la même plateforme est interdit et peut entraîner la fermeture de tous vos comptes.',
    },
    {
      question: 'Comment savoir si une plateforme est sûre ?',
      answer: 'Vérifiez que la plateforme possède un agrément ANJ (numéro visible en bas de page). Recherchez également les avis d\'autres utilisateurs, les certifications de sécurité (SSL), et les politiques de protection des données. Toutes les plateformes que nous recommandons respectent ces critères.',
    },
    {
      question: 'Que faire en cas de problème avec une plateforme ?',
      answer: 'Contactez d\'abord le service client de la plateforme. Si le problème persiste, vous pouvez contacter le Médiateur des Jeux en Ligne de l\'ANJ. Nous pouvons également vous aider à résoudre certains problèmes via notre formulaire de contact.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-dark-bg">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <HelpCircle className="w-12 h-12 text-toxic-green" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Questions <span className="text-toxic-green">Fréquentes</span>
          </h2>
          <p className="text-xl text-gray-400">
            Trouvez rapidement les réponses à vos questions
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-dark-card border-2 border-gray-800 rounded-xl overflow-hidden hover:border-toxic-green transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none"
              >
                <span className="text-lg font-semibold text-white pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-toxic-green flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

